<template>
  <div>
    <div class="table-header clearfix">
      <div class="actions pull-right">
        <b-dropdown id="legend" text="Legend" right variant="primary" class="m-md-2">
          <b-dropdown-item>
             <i title="Run job" class="text-success fa fa-play" aria-hidden="true"></i>
             Start job
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job has been submitted" class="text-primary fa fa-hourglass-o" aria-hidden="true"></i>
              Job submitted
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job has been accepted" class="text-primary fa fa-hourglass-start" aria-hidden="true"></i>
             Job accepted
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job is waiting on resources" class="text-primary fa fa-hourglass-half" aria-hidden="true"></i>
             Job queued
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job is getting ready to run" class="text-primary fa fa-hourglass-end" aria-hidden="true"></i>
             Job starting
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job is in progress" class="text-primary fa fa-spinner fa-spin" aria-hidden="true"></i>
             Job in progress
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job completed" class="text-success fa fa-check" aria-hidden="true"></i>
             Job completed
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job did not finish" class="text-danger fa fa-times" aria-hidden="true"></i>
             Job failed
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Job has not run recently" class="text-warning fa fa-2x fa-clock-o" aria-hidden="true"></i>
             Job has not run recently
          </b-dropdown-item>
          <b-dropdown-item>
            <i title="Job schedule is enabled" class="text-success fa fa-2x fa-clock-o" aria-hidden="true"></i>
            Job schedule is enabled
          </b-dropdown-item>
          <b-dropdown-item>
            <i title="Job schedule is disabled" class="text-danger fa fa-2x fa-clock-o" aria-hidden="true"></i>
            Job schedule is disabled
          </b-dropdown-item>
          <b-dropdown-item>
             <i title="Environment not configured" class="text-danger fa fa-exclamation-triangle" aria-hidden="true"></i>
             Environment not found
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <h4 class="table-title pull-left">Recurring Jobs</h4>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :defaultSortBy="{field: 'name', type: 'asc'}"
      :globalSearch="true"
      :paginate="true"
      :perPage="50"
      styleClass="table condensed table-bordered table-striped">
      <template slot="table-column" scope="props">
         <span v-if="props.column.label === 'Staging'">
            <span class="hidden-xs">
              {{props.column.label}}
            </span>
            <i class="fa fa-wrench" aria-hidden="true" :title="props.column.label"></i>
         </span>
         <span v-else-if="props.column.label === 'Production'">
            <span class="hidden-xs">
              {{props.column.label}}
            </span>
            <i class="fa fa-eye" aria-hidden="true" :title="props.column.label"></i>
         </span>
         <span v-else>
            {{props.column.label}}
         </span>
      </template>
      <template slot="table-row" scope="props">
        <td class="fancy">{{ props.row.name }}</td>
        <td class="text-center">
          <span v-if="props.row.environments.staging">
            <span v-if="props.row.environments.staging.history">
              <span v-if="props.row.environments.staging.history.status === 'SUBMITTED'">
                <i title="Job has been submitted" class="text-primary fa fa-2x fa-hourglass-o" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.staging.history.status === 'PENDING'">
                <i title="Job has been accepted" class="text-primary fa fa-2x fa-hourglass-start" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.staging.history.status === 'RUNNABLE'">
                <i title="Job is waiting on resources" class="text-primary fa fa-2x fa-hourglass-half" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.staging.history.status === 'STARTING'">
                <i title="Job is getting ready to run" class="text-primary fa fa-2x fa-hourglass-end" aria-hidden="true"></i>
              </span>
              <span v-else>
                <router-link :to="{ name: 'Job Log', params: { jobId: props.row.environments.staging.history.jobId }}">
                  <span v-if="props.row.environments.staging.history.status === 'SUCCEEDED'">
                    <i title="Job completed" class="text-success fa fa-2x fa-check" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.environments.staging.history.status === 'FAILED'">
                    <i title="Job did not finish" class="text-danger fa fa-2x fa-times" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.environments.staging.history.status === 'RUNNING'">
                    <i title="Job is in progress" class="text-primary fa fa-2x fa-spinner fa-spin" aria-hidden="true"></i>
                  </span>
                </router-link>
              </span>
            </span>
            <span v-else>
              <i title="Job has not run recently" class="text-warning fa fa-2x fa-clock-o" aria-hidden="true"></i>
            </span>
            <span v-if="!props.row.environments.staging.history || props.row.environments.staging.history.status.match(/SUCCEEDED|FAILED/)">
              <a @click="runJob(props.row.environments.staging)">
                <i title="Run job" class="text-success fa fa-2x fa-play" aria-hidden="true"></i>
              </a>
            </span>
            <a @click="toggleSchedule(props.row.environments.staging)">
              <span v-if="props.row.environments.staging.enabled">
                <i title="Job schedule is enabled" class="text-success fa fa-2x fa-clock-o" aria-hidden="true"></i>
              </span>
              <span v-else>
                <i title="Job schedule is disabled" class="text-danger fa fa-2x fa-clock-o" aria-hidden="true"></i>
              </span>
            </a>
          </span>
          <span v-else>
            <i title="Environment not configured" class="text-danger fa fa-2x fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </td>
        <td class="text-center">
          <span v-if="props.row.environments.production">
            <span v-if="props.row.environments.production.history">
              <span v-if="props.row.environments.production.history.status === 'SUBMITTED'">
                <i title="Job has been submitted" class="text-primary fa fa-2x fa-hourglass-o" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.production.history.status === 'PENDING'">
                <i title="Job has been accepted" class="text-primary fa fa-2x fa-hourglass-start" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.production.history.status === 'RUNNABLE'">
                <i title="Job is waiting on resources" class="text-primary fa fa-2x fa-hourglass-half" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.environments.production.history.status === 'STARTING'">
                <i title="Job is getting ready to run" class="text-primary fa fa-2x fa-hourglass-end" aria-hidden="true"></i>
              </span>
              <span v-else>
                <router-link :to="{ name: 'Job Log', params: { jobId: props.row.environments.production.history.jobId }}">
                  <span v-if="props.row.environments.production.history.status === 'SUCCEEDED'">
                    <i title="Job completed" class="text-success fa fa-2x fa-check" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.environments.production.history.status === 'FAILED'">
                    <i title="Job did not finish" class="text-danger fa fa-2x fa-times" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.environments.production.history.status === 'RUNNING'">
                    <i title="Job is in progress" class="text-primary fa fa-2x fa-spinner fa-spin" aria-hidden="true"></i>
                  </span>
                </router-link>
              </span>
            </span>
            <span v-else>
              <i title="Job has not run recently" class="text-warning fa fa-2x fa-clock-o" aria-hidden="true"></i>
            </span>
            <span v-if="!props.row.environments.production.history || props.row.environments.production.history.status.match(/SUCCEEDED|FAILED/)">
              <a @click="runJob(props.row.environments.production)">
                <i title="Run job" class="text-success fa fa-2x fa-play" aria-hidden="true"></i>
              </a>
            </span>
            <a @click="toggleSchedule(props.row.environments.production)">
              <span v-if="props.row.environments.production.enabled">
                <i title="Job schedule is enabled" class="text-success fa fa-2x fa-clock-o" aria-hidden="true"></i>
              </span>
              <span v-else>
                <i title="Job schedule is disabled" class="text-danger fa fa-2x fa-clock-o" aria-hidden="true"></i>
              </span>
            </a>
          </span>
          <span v-else>
            <i title="Environment not configured" class="text-danger fa fa-2x fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </td>
      </template>
    </vue-good-table>
    <router-view />
  </div>
</template>

<script>
  import { RaptorJobs } from '../services/raptor-jobs'

  let raptorJobs

  export default {
    name: 'recurring-jobs',
    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval)
      next()
    },
    data () {
      return {
        columns: [{
          label: 'Name',
          field: 'name',
          filterable: true
        },
        {
          label: 'Staging',
          thClass: 'text-center'
        }, {
          label: 'Production',
          thClass: 'text-center'
        }],
        notifyState: {},
        rows: []
      }
    },
    methods: {
      toggleSchedule (job) {
        const state = (job.enabled ? 'Disable' : 'Enable')

        this.$dialog.confirm('<p>' + state + ' Job?</p>', {
          loader: true,
          html: true,
          okText: state,
          cancelText: 'Cancel'
        }).then((dialog) => {
          raptorJobs.enableSchedule(job).then(() => {
            dialog.close()
            this.$notify({
              title: 'Job schedule is now ' + state.toLowerCase() + 'd'
            })
            clearInterval(this.interval)
            this.refreshJobs()
            this.interval = setInterval(() => this.refreshJobs(), 15000)
          }, (error) => {
            dialog.close()
            this.$notify({
              title: 'Unable enable schedule',
              text: error.message || error.toString(),
              type: 'alert-danger',
              duration: 5000
            })
          })
        }).catch(() => {
          // Do nothing
        })
      },
      runJob (job) {
        if (job.target.split(':').pop() === 'raptorPagesJob') {
          job.queue = 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorPagesUpdates'
        } else {
          job.queue = 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates'
        }

        this.$dialog.confirm('<p>Are you sure you want to start this job?</p><small>Running a job incurs hosting costs.</small>', {
          loader: true,
          html: true,
          okText: 'Run Job',
          cancelText: 'Cancel'
        }).then((dialog) => {
          if (raptorJobs) {
            raptorJobs.runJob(job).then(() => {
              dialog.close()
              this.$notify({
                title: 'The job has been queued'
              })
              clearInterval(this.interval)
              this.refreshJobs()
              this.interval = setInterval(() => this.refreshJobs(), 15000)
            }, (error) => {
              dialog.close()
              this.$notify({
                title: 'Unable to start job',
                text: error.body.message || error.message || error.toString(),
                type: 'alert-danger',
                duration: 5000
              })
            })
          }
        }).catch(() => {
          // Do nothing
        })
      },
      refreshJobs () {
        this.$log.debug('Refreshing Jobs')

        raptorJobs.getRules([
          'arn:aws:lambda:us-east-1:976741133712:function:raptorSchemaJob',
          'arn:aws:lambda:us-east-1:976741133712:function:raptorPagesJob'
        ], [
          'raptorSchemaUpdates',
          'raptorPagesUpdates'
        ]).then((rules) => {
          this.$log.debug('Received AWS Job Data', rules)
          this.rows = rules

          rules.forEach((rule) => {
            try {
              Object.keys(rule.environments)
                .filter((environment) => rule.environments[environment].history)
                .forEach((environment) => {
                  const key = rule.arn + environment
                  const state = rule.environments[environment].history.status

                  if (key in this.notifyState) {
                    if (this.notifyState[key] !== state && this.notifyState[key] === 'RUNNING') {
                      this.$notification.show(rule.name, {
                        body: state
                      }, { })
                    }
                  }

                  this.notifyState[key] = state
                })
            } catch (error) {
              this.$log.error(error)
            }
          })
        }).catch((error) => {
          if (error.code === 'ExpiredTokenException' || error.code === 'CredentialsError') {
            this.$auth.signOut()
          } else {
            this.$log.warn(JSON.stringify(error))

            this.$notify({
              title: 'AWS API Error',
              text: error.message ? error.message : 'Gateway issue',
              type: 'alert-warning',
              duration: 5000
            })
          }
        })
      }
    },
    mounted () {
      this.$log.debug('Dashboard mounted')

      raptorJobs = new RaptorJobs()

      this.refreshJobs()

      this.interval = setInterval(() => this.refreshJobs(), 15000)
    }
  }
</script>

<style>
  #legend {
    margin: 0 !important;
  }

  .fa-2x {
    font-size: 1.4em;
  }

  .fancy {
    width: 70%;
  }

  .table.condensed thead th {
    white-space: nowrap;
  }

  .table i {
    margin: 0 2px;
  }

  .table a i {
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .table-header {
      margin: 5px;
    }

    .table.condensed thead th {
      padding: .4rem !important;
    }

    .main .container-fluid {
      padding: 0px;
    }

    .hidden-xs {
      display: none;
    }

    .fa-2x {
      font-size: 1em;
    }

    .fancy {
      width: 60%;
    }
  }
</style>


// WEBPACK FOOTER //
// RecurringJobs.vue?689d7721